/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

interface IPair {
    eventTypes: string[],
    apiMethod: string
}

const pairs :IPair[] = [
    {
        eventTypes: ['click'],
        apiMethod: 'click'
    },
    {
        eventTypes: ['mouseover'],
        apiMethod: 'mouseover'
    },
    {
        eventTypes: ['mouseenter'],
        apiMethod: 'mouseenter'
    },
    {
        eventTypes: ['mouseout'],
        apiMethod: 'mouseout'
    }
];

export default pairs;
